import ReactECharts from "echarts-for-react";
import {useFindPathTrackingByEuiAndDate} from "hooks/queries/path-tracking.query"
import {EChartsOption, LineSeriesOption} from "echarts"
import dayjs from "dayjs"
import {useRootStore} from "store/useRootStore"
import {observer} from "mobx-react"

const labelOption = {show: true, rotate: -45, fontSize: 8,}
const differenceDiscriminant = (value: number): number => {
    return value
}
export const PathTrackingChartWindow = observer(() => {
    useRootStore()
    const {data: result} = useFindPathTrackingByEuiAndDate()
    const list = result?.content.sort((a, b) => a.id - b.id) || []

    const xValues = list.map(pt => {
        return dayjs(pt.receivedAt).format("HH:mm:ss")
    }) || []
    const gradientXValues = list.map(pt => {
        const gradient = pt.gradient?.x || 0
        return differenceDiscriminant(gradient)
    }) || []

    const gradientYValues = list.map(pt => {
        const gradient = pt.gradient?.y || 0
        return differenceDiscriminant(gradient)
    }) || []

    // console.log("list : ", list, gradientXValues, gradientYValues)
    const gradientXSeriesOption: LineSeriesOption = {
        name: "좌우기울기",
        type: 'line',
        seriesLayoutBy: "column",
        data: gradientXValues,
        smooth: true,
        label: {...labelOption, color: "red"}
    }

    const gradientYSeriesOption: LineSeriesOption = {
        name: "앞뒤기울기",
        type: 'line',
        seriesLayoutBy: "column",
        data: gradientYValues,
        smooth: true,
        label: {...labelOption, color: "green"}
        // label: {...labelOption, color: "black"}
    }

    const option: EChartsOption = {
        legend: {top: -5},
        series: [gradientXSeriesOption, gradientYSeriesOption],
        yAxis: {
            type: "value",
            name: "측정값",
            nameTextStyle: {
                align: "right",
                fontWeight: "bolder",
                fontSize: 12
            }
        },
        xAxis: {
            type: "category",
            name: "시간",
            data: xValues,
        },
        grid: {
            top: 30,
            bottom: 20,
            left: 40,
            right: 0
        }
    }
    return (
        <div className="pop-content"
             style={{
                 display: "block", position: "absolute",
                 top: "auto", bottom: 0, right: 0, left: 0, height: 300, width: "100%",
                 margin: 5, padding: 30, background: "none", paddingBottom: 10,
             }}>
            <div className="mainbody" style={{height: "100%", background: 'rgba(255,255,255,0.5)', borderRadius: 15}}>
                <div className="main-box">
                    <div className="grid-table2 grid-pop-table">
                        <ReactECharts
                            theme={"shine"}
                            option={option}
                            style={{width: "100%", height: 200}}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
})